import * as React from "react";
import { connect } from "react-redux";
import { IdResource } from "../../constants/IdResource";
import { IdStyles } from "../../less/IdStyles";
import { selectDiscountBuffPercentageAmount, selectPrimeTimeBuffPercentageAmount, } from "../../selectors/selectBuffsInfo";
import { selectSelectedDiscountEvent } from "../../selectors/selectDiscountEvent";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilEvent } from "../../utils/utilEvent";
import { utilNumber } from "../../utils/utilNumber";
import { EventType } from "../balancing/types/BalancingCore";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonSecondaryAccentExtraLarge } from "../generic/common/ButtonSecondaryAccentExtraLarge";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { TimeRemaining } from "../time/TimeRemaining";
import { actionDiscountEventShowMe } from "./actionDiscountEvent";
export var _DialogDiscountEvent = function (_a) {
    var discountEvent = _a.discountEvent, discountBuffAmount = _a.discountBuffAmount, onClose = _a.onClose, onShowMe = _a.onShowMe;
    var footer = React.createElement(TimeRemaining, { remainingTime: utilEvent.getEndTime(discountEvent) });
    var percentageLocaReplacement = new Map([
        [ReplacementLoca.zero_0, utilNumber.format(discountBuffAmount || 0)],
    ]);
    var _b = getDialogContent(discountEvent.balancing.type), titleLocaId = _b[0], descLocaId = _b[1], icon = _b[2];
    return (React.createElement(DialogWrapper, { titleLocaId: titleLocaId, onClose: onClose, className: IdStyles.ModalBackgroundLevelUp, footerRenderer: footer },
        React.createElement("div", { className: "flex flex--evenly" },
            React.createElement("div", { className: "flex flex--stacked flex--aligned" },
                React.createElement("div", { className: "flex w100 flex--spaced flex--aligned pl__medium pt__medium pb__small" },
                    React.createElement("div", { className: "discount-event-dialog__decoration-top-left" }),
                    React.createElement("div", { className: "discount-event-dialog__decoration-top-right mirrorX" })),
                React.createElement("div", { className: IdStyles.DiscountAmountContainer + " flex flex--aligned" },
                    React.createElement(Icon, { icon: icon, styleId: IdStyles.IconExtraLarge }),
                    React.createElement("div", { className: "discount-event-dialog__discount-amount" },
                        React.createElement(TextLoca, { id: IdLoca.value_percentage, className: IdStyles.HeadlineOne, replacements: percentageLocaReplacement }))),
                React.createElement("div", { className: "discount-event-dialog__decoration-bottom" })),
            React.createElement("div", { className: "flex flex--stacked flex--centered flex--aligned" },
                React.createElement("div", { className: IdStyles.DiscountDescriptionContainer + " " + IdStyles.TextNormal + " discount-event-dialog__description" },
                    React.createElement(TextLoca, { replacements: percentageLocaReplacement, id: descLocaId })),
                React.createElement(ButtonSecondaryAccentExtraLarge, { onClick: onShowMe },
                    React.createElement("div", { className: "flex flex--stacked flex--guts" },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.showMe }),
                        React.createElement("div", { className: "flex flex--guts" },
                            React.createElement(Icon, { icon: IdIcon.GreenArrowIcn, styleId: IdStyles.IconMedium }))))))));
};
var getDialogContent = function (eventType) {
    var mapEventTypeToLocaIds = new Map([
        [
            EventType.FancyHouseDiscount,
            [
                IdLoca.fancyHouseDiscountDialog_title,
                IdLoca.fancyHouseDiscountDialog_desc,
                IdIcon.PrimeSaleIcn,
            ],
        ],
        [
            EventType.FertileAcreDiscount,
            [
                IdLoca.fertileAcreDiscountDialog_title,
                IdLoca.fertileAcreDiscountDialog_desc,
                IdIcon.PrimeSaleIcn,
            ],
        ],
        [
            EventType.ExpansionDiscount,
            [
                IdLoca.expansionDiscountDialog_title,
                IdLoca.expansionDiscountDialog_desc,
                IdIcon.ExpansionSaleIcn,
            ],
        ],
        [
            EventType.OutskirtDiscount,
            [
                IdLoca.externalBarnDiscountDialog_title,
                IdLoca.externalBarnDiscountDialog_desc,
                IdIcon.PrimeSaleIcn,
            ],
        ],
        [
            EventType.PrimeTime,
            [IdLoca.primeTimeDialog_title, IdLoca.primeTimeDialog_desc, IdIcon.PrimeSaleIcn],
        ],
    ]);
    return mapEventTypeToLocaIds.get(eventType);
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.DiscountEvent)); },
    onShowMe: function () { return dispatch(actionDiscountEventShowMe()); },
}); };
var mapState = function (state) {
    var discountEvent = selectSelectedDiscountEvent(state);
    var discountBuffAmount;
    if (discountEvent && discountEvent.balancing) {
        if (discountEvent.balancing.type === EventType.PrimeTime) {
            discountBuffAmount = selectPrimeTimeBuffPercentageAmount(state, discountEvent);
        }
        else {
            discountBuffAmount = selectDiscountBuffPercentageAmount(state, discountEvent, IdResource.Gold);
        }
    }
    return {
        discountBuffAmount: discountBuffAmount,
        discountEvent: discountEvent,
    };
};
export var DialogDiscountEvent = connect(mapState, mapDispatch)(_DialogDiscountEvent);



//////////////////
// WEBPACK FOOTER
// ./src/features/discount-event/DialogDiscountEvent.tsx
// module id = 2814
// module chunks = 3